var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.column)?_c('button',{staticClass:"table-head-cell w-full flex items-center cursor-pointer",class:{
    'justify-start': _vm.alignLeft,
    'justify-center': _vm.alignCenter,
    'justify-end': _vm.alignRight,
  },attrs:{"type":"button"},on:{"click":_vm.changeSort}},[_vm._v(" "+_vm._s(_vm.column.name)+" "),(_vm.column.useSort && _vm.isSorted)?_c('span',{staticClass:"table-head-sort ml-2",class:{
      'table-head-sort-asc': _vm.sort === _vm.sortTypes.asc,
      'table-head-sort-desc': _vm.sort === _vm.sortTypes.desc,
      'table-head-sort-none': _vm.sort === _vm.sortTypes.none,
    }},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 6L10 13L17 6","stroke":"#686F90","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }